export const SHOW_BULK_MESSAGE_MODAL = 'bulk-message/modal/show';
export const CLOSE_BULK_MESSAGE_MODAL = 'bulk-message/modal/close';
export const SEND_BULK_MESSAGE = 'bulk-message/send';
